import React from 'react';
import { KnownService, KnownServiceComponentProps } from './known-service';

import styles from './styles.less';

interface OwnProps extends KnownServiceComponentProps {
  url: string;
  user: string;
  repo: string;
  hash: string;
}

export const GitHubCommitComponent: React.FunctionComponent<OwnProps> = ({
  user,
  url,
  repo,
  hash,
  ...anchorProps
}) => (
  <a {...anchorProps} href={url} className={styles.knownServiceLink}>
    <img
      className={styles.knownServiceIcon}
      alt="Github Icon"
      src={require('resources/images/services/github.png')}
    />
    {user}/{repo}: {hash.substr(0, 7)}
  </a>
);

export const GitHubCommit: KnownService<OwnProps> = {
  match: {
    protocol: 'https:',
    host: 'github.com',
    pathname: new RegExp(`\
^\
/\
([^/]+)/\
([^/]+)/\
commit/\
([^/]{7,40})\
$\
`),
  },
  getMatchProps: ([url, _, user, repo, hash]: string[]) => {
    return { url, user, repo, hash };
  },
  Component: GitHubCommitComponent,
};
